import { type ComponentType } from "react";

import { PROJECT_ID_VARIATIONS } from "../../utils/gcpUtils";
import { GCPProjectStringParam } from "../parameters/GCPProjectStringParam";
import { type ComponentResolver, type FieldResolverContext, type StringParamProps } from "./ComponentResolver";

export const gcpComponentResolver: ComponentResolver = {
  resolveStringComponent: (context: FieldResolverContext): ComponentType<StringParamProps> | null => {
    const isGcpProjectField = PROJECT_ID_VARIATIONS.some((variation) =>
      context.fieldName.toLowerCase().endsWith(variation)
    );

    if (isGcpProjectField) {
      return GCPProjectStringParam;
    }

    return null;
  },
};
